import { authFormPost, authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;
const mediaDomain = process.env.REACT_APP_MEDIA_DOMAIN;

export function postAgent22Api(params) {
  return authPost(`${baseUrl}/Agent22.ashx`, params);
}

export function createGame(params, url) {
  return authFormPost(url, params);
}
